import React, {useState} from "react";

import Challenge from "./Challenge.jsx";
import {formatTime} from "./ChallengeUtil.jsx";
import './ChallengesScreen.css'
import challenges from '../assets/learning-feed/challenges.json';

export default function ChallengesScreen() {

  const [currentChallenge, setCurrentChallenge] = useState();

  function endChallenge() {
    setCurrentChallenge(null);
  }

  let challengesList = <div className="challenges-list">
    {challenges.challenges.map((challenge, index) => (<React.Fragment key={index}>
        <div key={index+"_details"} className="challenges-list-details">
          <h1 className="challenge-title">{challenge.title}</h1>
          <div className="challenge-list-stats">
            <div className="challenge-stat">Questions: {challenge.questions.length}</div>
            <div className="challenge-stat">Time: {formatTime(challenge.time)}</div>
          </div>
          <p className="challenge-description">{challenge.description}</p>
        </div>
        <div key={index+"_cta"} className="challenges-list-cta">
          <button className="challenge-start-button" onClick={() => setCurrentChallenge(challenge)}>Start</button>
        </div>
      </React.Fragment>
    ))}
  </div>

  if (currentChallenge) {
    return <Challenge challenge={currentChallenge} onExit={endChallenge}/>
  } else {
    return challengesList;
  }
}